angular.module('app.api').factory('CandidateListingApi', [
  'api',
  function CandidateListingApi(api) {
    const candidateListingApi = {
      getCandidateListing: async payload => {
        return api.get('listings/user', {params: payload})
      },
      updateBulkUserAgents: async data => {
        return api.put('bulk/users/agent', data)
      },
      deleteUsers: async userIds => {
        return api.delete(`bulk/users`, {params: {userIds}})
      },
    }
    return candidateListingApi
  },
])



// WEBPACK FOOTER //
// ./scripts/admin-panel/candidate-listing/candidate-listing.api.js